// @ts-nocheck
import React, {useMemo} from 'react';
import {StyleSheet, View} from 'react-native';
import {useSelector} from 'react-redux';
import {hideAlert} from '../../actions/AlertActions';
import {store} from '../../store/index';
import LoadingOverlay from '../loading-overlay/LoadingOverlay';
import {selectrootalerttype} from '../../selectors/AlertSelector';
import AlertBox from '../alert-box/AlertBox.component';

const Modals = {
  Loading: LoadingOverlay,
  AlertBox: AlertBox,
};

const RootAlert = () => {
  const {id, modalProps} = useSelector(state => selectrootalerttype(state));
  const ModalView = useMemo(() => Modals[id] as any, [id]);
  return (
    <>
      {ModalView && (
        <View style={styles.container}>
          <ModalView
            {...modalProps}
            onRequestClose={() => store.dispatch(hideAlert())}
          />
        </View>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex  : 1000
  },
});

export default RootAlert;
